import { createContext } from 'react';

import type { ValueRepresentation } from '../../core/types/scales.js';

export const HistogramValueRepresentationContext = createContext<
  ValueRepresentation | undefined
>(undefined);

HistogramValueRepresentationContext['displayName'] =
  'HistogramValueRepresentationContext';
